<!-- Settings. Six toggles bound to `settings`, each with a one-line
     explanation, and an About section. Nothing here navigates anywhere
     except back. -->
<template>
  <IonPage>
    <AppHeader title="Settings" back="/" />

    <IonContent :fullscreen="true">
      <div class="soc-stack settings-stack">
        <IonList :inset="true">
          <IonListHeader>
            <IonLabel>Accessibility</IonLabel>
          </IonListHeader>
          <IonItem>
            <IonLabel>
              <h3>Reduced motion</h3>
              <p>Turns off camera drift, particles and score count-ups.</p>
            </IonLabel>
            <IonToggle slot="end" :checked="settings.reducedMotion" aria-label="Reduced motion" @ionChange="set('reducedMotion', $event)" />
          </IonItem>
          <IonItem>
            <IonLabel>
              <h3>High-contrast routes</h3>
              <p>Thickens cables and outlines the active route in white.</p>
            </IonLabel>
            <IonToggle slot="end" :checked="settings.highContrast" aria-label="High-contrast routes" @ionChange="set('highContrast', $event)" />
          </IonItem>
          <IonItem :lines="'none'">
            <IonLabel>
              <h3>Practice speed</h3>
              <p>Slows the spark down. Practice rounds don't set personal bests.</p>
            </IonLabel>
            <IonToggle slot="end" :checked="settings.practiceSpeed" aria-label="Practice speed" @ionChange="set('practiceSpeed', $event)" />
          </IonItem>
        </IonList>

        <IonList :inset="true">
          <IonListHeader>
            <IonLabel>Sound</IonLabel>
          </IonListHeader>
          <IonItem>
            <IonLabel>
              <h3>Sound</h3>
              <p>Turns sound effects on or off.</p>
            </IonLabel>
            <IonToggle slot="end" :checked="settings.sound" aria-label="Sound" @ionChange="set('sound', $event)" />
          </IonItem>
          <IonItem>
            <IonLabel>
              <h3>Music</h3>
              <p>Turns the background music on or off.</p>
            </IonLabel>
            <IonToggle slot="end" :checked="settings.music" aria-label="Music" @ionChange="set('music', $event)" />
          </IonItem>
          <IonItem :lines="'none'">
            <IonLabel>
              <h3>Haptics</h3>
              <p>Gentle vibration for taps and completed homes. Native only.</p>
            </IonLabel>
            <IonToggle slot="end" :checked="settings.haptics" aria-label="Haptics" @ionChange="set('haptics', $event)" />
          </IonItem>
        </IonList>

        <section class="soc-card about">
          <h2 class="section-title first">About</h2>
          <p class="soc-muted">{{ APP_NAME }} · version {{ WEB_BUILD }}</p>
          <p class="soc-muted">A concept prototype.</p>
          <a class="soc-link" href="mailto:support@harfredlabs.com">support@harfredlabs.com</a>
        </section>
      </div>
    </IonContent>
  </IonPage>
</template>

<script setup>
import { IonPage, IonContent, IonList, IonListHeader, IonItem, IonLabel, IonToggle } from '@ionic/vue';
import { AppHeader } from '../core/ui';
import { settings, saveSettings } from '../store.js';
import { APP_NAME, WEB_BUILD } from '../../app-config.js';

function set(key, ev) {
  settings[key] = !!ev.detail.checked;
  saveSettings();
}
</script>

<style scoped>
.settings-stack {
  padding-top: var(--sp-4);
}

.about {
  text-align: center;
  display: flex;
  flex-direction: column;
  gap: var(--sp-2);
  align-items: center;
}

.about p {
  margin: 0;
}

.section-title.first {
  margin-top: 0;
}
</style>
